import React, { useState, useEffect } from 'react'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { setUserActive, showPopup } from '../actions'
import { tokerUser } from '../hooks/user';
import { connect } from 'react-redux'
import './UserInfo.scss'
import axios from 'axios'
import ChangePassUserForm from './ChangePassUserForm'
import { useActiveDesactiveSrollBody } from '../hooks/activeDesactivScrollBody'
import { comprobarDatos } from '../hooks/validateForm'
import { API, CambiarColoresPrincipales } from '../hooks/config'

const UserInfo = (props) => {
    const { zones } = props
    const [user, setUser] = useState(props.userData)
    const [formChangePass, setFormChangePass] = useState(false)
    const reglas = {
        email: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            email: { message: 'con un formato invalido' },
        },
        empresa: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        cif: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        name: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        phonenumber: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            format: { pattern: '[0-9]+', message: 'solo puede contener digitos del 0 al 9' },
        },
        zone: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
    };

    CambiarColoresPrincipales('fansa')

    // componentWillUnmount using useEffect
    useEffect(() => {
        return () => {
          CambiarColoresPrincipales()
        }
    }, [])

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUser(() => ({
            ...user,
            [name]: value
        }))
    }

    const handleClickSaveDataUser = () => {
        const alias = {
            name: 'nombre',
            phonenumber: 'teléfono',
            zone: 'zona',
        }
        comprobarDatos(user, reglas, alias).then(res => {
            tokerUser().then(res => {
                const tokenUser = res
                const headers = {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${tokenUser}`
                    }
                };
                axios.post(`${API}/protected/users`, {
                    id: user.id,
                    company: user.empresa,
                    cif: user.cif,
                    name: user.name,
                    phoneNumber: user.phonenumber,
                    zone: user.zone,
                    email: user.email,
                    role: user.role,
                }, headers).then(res => {
                    props.showPopup({ active: true, message: 'Datos guardados', type: 'success' })
                    props.setUserActive(user)
                }).catch(err => {
                    props.showPopup({ active: true, message: 'Error al guardar', type: 'success' })
                });
            })
        }).catch(err => {
            props.showPopup({ active: true, message: err, type: 'error' })
        })
    }

    const clickChangePass = () => {
        useActiveDesactiveSrollBody(true)
        setFormChangePass(true)
    }

    const clickChangePassCloseForm = () => {
        useActiveDesactiveSrollBody(false)
        setFormChangePass(false)
    }

    return (
        <div className="user-info-container">
            {formChangePass &&
                <ChangePassUserForm user={user} clickClose={clickChangePassCloseForm} />
            }
            <div className="form">
                <div className="input-block email">
                    <label htmlFor="email">Email:</label>
                    <div className="input">
                        <input type="text" name="email" onChange={handleChange} value={user.email} />
                    </div>
                </div>
                <div className="input-block company">
                    <label htmlFor="empresa">Empresa:</label>
                    <div className="input">
                        <input type="text" name="empresa" onChange={handleChange} value={user.empresa} />
                    </div>
                </div>
                <div className="input-block cif">
                    <label htmlFor="cif">CIF:</label>
                    <div className="input">
                        <input type="text" name="cif" onChange={handleChange} value={user.cif} />
                    </div>
                </div>
                <div className="input-block name">
                    <label htmlFor="name">Nombre y apellidos:</label>
                    <div className="input">
                        <input type="text" name="name" onChange={handleChange} value={user.name} />
                    </div>
                </div>
                <div className="input-block phoneNumber">
                    <label htmlFor="phonenumber">Teléfono:</label>
                    <div className="input">
                        <input type="text" name="phonenumber" onChange={handleChange} value={user.phonenumber} />
                    </div>
                </div>
                <div className="input-block select">
                    <label htmlFor="zone">Zona:</label>
                    <Select
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            },
                            getContentAnchorEl: null
                        }}
                        name="zone"
                        IconComponent={ArrowForwardIosIcon}
                        value={user.zone}
                        id="select"
                        onChange={handleChange}>
                        {zones.region.map((zone, index) => {
                            return (
                                <MenuItem className={zones.region.length - 1 === index ? "regions-end" : ""} value={zone.Name} key={index}>{zone.Name}</MenuItem>
                            )
                        })}
                        {zones.country.map((zone, index) => {
                            return (
                                <MenuItem value={zone.Name} key={index}>{zone.Name}</MenuItem>
                            )
                        })}
                    </Select>
                </div>
            </div>
            <div className="botones">
                <p><a className="pointer" onClick={clickChangePass}>Modificar contraseña</a></p>
                <button className="btn" onClick={handleClickSaveDataUser}>Guardar</button>
            </div>
        </div>
    )
}

const mapStateToProps = state => state

const mapDispatchToProps = {
    setUserActive,
    showPopup
}

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo)
